export enum HOME_SPORT_GROUPS {
	CRICKET = 4,
	SOCCER = 1,
	TENNIS = 2,
	HORSE_RACING = 7,
	GREYHOUND_RACING = 4339,
}
